import React, { useEffect } from 'react';
import qs from 'query-string';
import { OpenType } from '@/constant/download';
import { webSlsDownloadLogger } from '@/lib/log/sls/slsDownloadLog';
import jumpToDownload from '@/helper/jumpToDownload';
import wakeupApp from '@/helper/wakeupApp';
import { downloadUrl } from '@/constant/download';
import DownloadView1 from '@/components/DownloadView1';
import '@/scss/normalize.scss';

const Home = () => {
  const qsParams = qs.parse(window.location.search);
  const {
    open = '',
    url = '',
    utm_source,
    utm_medium,
    utm_campaign,
    utm_term,
    utm_content,
  } = qsParams;

  useEffect(() => {
    webSlsDownloadLogger('app_download_page_enter');

    switch (open) {
      case OpenType.SCHEME:
        // 尝试scheme打开App
        webSlsDownloadLogger('app_download_try_scheme');
        let scheme = downloadUrl.scheme;
        const query: any = {
          utm_source,
          utm_medium,
          utm_campaign,
          utm_term,
          utm_content,
        };
        if (url) {
          query.url = url;
        }
        location.href = `${scheme}?${qs.stringify(query)}`;
        break;

      case OpenType.APPSTORE:
        // 跳转App Store
        webSlsDownloadLogger('app_download_jump_app_store');
        jumpToDownload();
        break;

      case OpenType.SCHEMEANDAPPSTORE:
        // 尝试唤起app并跳转App Store
        webSlsDownloadLogger('app_download_try_wakeupApp');
        wakeupApp();
        break;

      default:
        break;
    }
  }, []);

  const onDownload = () => {
    jumpToDownload();
    webSlsDownloadLogger('app_download_btn_click');
  };
  return <DownloadView1 onDownload={onDownload} />;
};

export default Home;
